import { Link } from 'react-router-dom';
// mantine
import { Button, Table, UnstyledButton } from '@mantine/core';
// icons
import { Trash2, Info, Book, FileCog } from 'lucide-react';
// utils
import { TPersona } from '@newo/api/gateway';
import { useDeletePersonaMutation } from '@/services/customer/personas/personas.queries.ts';
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
import { PATHS } from '@/const';

interface PersonaRowProps {
    onDelete: () => void;
    onEdit: () => void;
    persona: TPersona;
    onGoToAKB: (persona: TPersona) => void;
}

const PersonaRow = ({
    onDelete,
    onEdit,
    persona,
    onGoToAKB
}: PersonaRowProps) => {
    const { mutate: deletePersona } = useDeletePersonaMutation();
    const handleDelete = () => {
        openConfirmDeleteModal({
            title: `Delete ${persona.name} persona?`,
            children: `Are you sure you want to delete ${persona.name} persona?`,
            confirmLabel: 'Delete Persona',
            onConfirm: () => {
                deletePersona(
                    { personaId: persona.id },
                    {
                        onSuccess: onDelete
                    }
                );
            }
        });
    };

    return (
        <Table.Tr>
            <Table.Td>{persona.name}</Table.Td>
            <Table.Td>{persona.description}</Table.Td>
            <Table.Td>
                <div className="flex gap-2">
                    <Button
                        leftSection={<Book />}
                        size="xs"
                        variant="default"
                        onClick={() => {
                            onGoToAKB(persona);
                        }}
                    >
                        AKB
                    </Button>
                    <Button
                        component={Link}
                        leftSection={<FileCog />}
                        size="xs"
                        to={`${PATHS.attributes.root}/personas/${persona.id}`}
                        variant="default"
                    >
                        Attributes
                    </Button>
                </div>
            </Table.Td>
            <Table.Td className="capitalize">
                {persona.agent?.idn ?? '-'}
            </Table.Td>
            <Table.Td>
                <div className="flex justify-end gap-4">
                    <UnstyledButton
                        className="leading-none"
                        title="Edit Personas"
                        onClick={onEdit}
                    >
                        <Info />
                    </UnstyledButton>
                    <UnstyledButton
                        className="leading-none"
                        title="Delete Personas"
                        onClick={handleDelete}
                    >
                        <Trash2 />
                    </UnstyledButton>
                </div>
            </Table.Td>
        </Table.Tr>
    );
};

export default PersonaRow;
